// @flow
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { TComma } from '../../../base/utils';
import { Note } from '../../../helbest';
import { API } from '../../../request/api';
import { Popup } from '../Popup/Popup';
import { CashCredit } from './CashCredit/CashCredit';
import { GiftCredit } from './GiftCredit/GiftCredit';
import styles from './Wallet.module.css';
import { WalletHeader } from './WalletHeader/WalletHeader';
import { WalletTabs } from './WalletTabs/WalletTabs';

const maxAmount = 100000000;
const minAmount = 100000;

// TODO: GET => creditSummery - POST => giftCreditCode, chargeWallet - API CONFIG
export const Wallet = ({ show, closePopup }) => {
  const tabs = [
    {
      name: 'شارژ هدیه',
      type: 'GIFT',
      component: GiftCredit
    },
    {
      name: 'شارژ نقدی',
      type: 'CASH',
      component: CashCredit
    }
  ];

  const [activeTab, setActiveTab] = useState('GIFT');
  const [currentCredit, setCurrentCredit] = useState(0);
  const [credits, setCredits] = useState([]);
  const [addStep, setAddStep] = useState();
  const [reduceStep, setReduceStep] = useState();
  const store = useSelector((state) => state);

  const getAsanPardakhtPaymentUrl = (refIdValue) => {
    const form = document.createElement('form');
    form.setAttribute('method', 'POST');
    form.setAttribute('action', 'https://asan.shaparak.ir');
    form.setAttribute('target', '_self');

    const hiddenField = document.createElement('input');
    hiddenField.setAttribute('name', 'RefId');
    hiddenField.setAttribute('value', refIdValue);
    form.appendChild(hiddenField);

    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  };

  const getCreditSummery = () => {
    API.get
      .creditSummery()
      .then((response) => {
        setCurrentCredit(TComma(response?.data?.general?.remaining_credit));
        return response;
      })
      .catch((error) => {
        console.error('Error : ', error);
      });
  };

  const getWalletConfig = () => {
    API.get
      .config('wallet_static_charge_config')
      .then((response) => {
        if (response.success) {
          setCredits(Object.values(response.data?.wallet_static_charge_config?.static_amount));
          setAddStep(response.data?.wallet_static_charge_config?.static_step?.add);
          setReduceStep(response.data?.wallet_static_charge_config?.static_step?.minus);
        }
        return response;
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error('Error : ', error);
      });
  };

  const postGiftCreditCode = (discount_code) => {
    API.post
      .giftCreditCode(discount_code)
      .then((response) => {
        if (response.success) {
          Note.success(response.message);
          getCreditSummery();
        } else {
          Note.error(response.message);
        }
        return response;
      })
      .catch((error) => {
        console.error('Error : ', error);
      });
  };

  const postChargeWallet = (amount) => {
    API.post
      .chargeWallet(store.Login.city_id, amount)
      .then((response) => {
        if (response.success) {
          if (response.data.payment_url) {
            window.location.replace(response.data.payment_url);
          } else {
            getAsanPardakhtPaymentUrl(response.data.token);
          }
        } else {
          Note.error(response.message);
        }
        return response;
      })
      .catch((error) => {
        console.error('Error : ', error);
      });
  };

  useEffect(() => {
    getCreditSummery();
    getWalletConfig();
  }, []);

  return (
    <Popup closePopup={closePopup} show={show}>
      <div className={styles.Wallet}>
        <WalletHeader closePopup={closePopup} />
        <WalletTabs activeTab={activeTab} setActiveTab={setActiveTab} tabs={tabs} />
        {tabs.map((tab) => {
          const Component = tab.component;
          return activeTab === tab.type ? (
            <Component
              addStep={addStep}
              credits={credits}
              currentCredit={currentCredit}
              maxAmount={maxAmount}
              minAmount={minAmount}
              postChargeWallet={postChargeWallet}
              postGiftCreditCode={postGiftCreditCode}
              reduceStep={reduceStep}
            />
          ) : null;
        })}
      </div>
    </Popup>
  );
};
